export const pause = (color = '#403F42') =>
	`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="7" y="7" width="4" height="11" rx="2" fill="${color}"/>
        <rect x="13" y="7" width="4" height="11" rx="2" fill="${color}"/>
    </svg>`;
